import type { ReactNode } from "react";

import { DetailSectionState } from "../detail-section-state";
import styles from "./detail-section.module.scss";
import type { DetailSectionViewModel } from "./types-detail-section";

export function DetailSectionView({
  id,
  title,
  testId,
  headingId,
  ultimaAtualizacaoTexto,
  ultimaAtualizacaoTestId,
  estado,
  children,
}: DetailSectionViewModel & { children?: ReactNode }) {
  return (
    <section
      className={styles.section}
      // O menu lateral e o diálogo localizam a seção por este atributo para rolar o corpo até ela.
      data-section-id={id}
      aria-labelledby={headingId}
      data-testid={testId}
    >
      <header className={styles.header}>
        <h2 className={styles.title} id={headingId}>
          {title}
        </h2>

        {ultimaAtualizacaoTexto === null ? null : (
          <p className={styles.lastUpdate} data-testid={ultimaAtualizacaoTestId}>
            {ultimaAtualizacaoTexto}
          </p>
        )}
      </header>

      <hr className={styles.divider} />

      {estado ? <DetailSectionState {...estado} /> : children}
    </section>
  );
}
